import { render, staticRenderFns } from "./incomeItem.vue?vue&type=template&id=119a430c&scoped=true"
import script from "./incomeItem.vue?vue&type=script&lang=js"
export * from "./incomeItem.vue?vue&type=script&lang=js"
import style0 from "./incomeItem.vue?vue&type=style&index=0&id=119a430c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119a430c",
  null
  
)

export default component.exports